import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      display: 'flex',
      flexFlow: 'column nowrap',
      borderBottom: theme.shape.borderGray70,
      paddingBottom: theme.spacing(2),
    },
    header: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'baseline',
      gap: theme.spacing(0.5),
      minWidth: 0,
      color: COLORS.text.primary,
    },
    icon: {
      fontSize: theme.typography.pxToRem(8),
      color: COLORS.error.active,
    },
    issue: {
      color: COLORS.error.active,
    },
    explanation: {
      marginTop: theme.spacing(2),
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'DetectedViolation' }
);
